import types from './types'

export const initialState = {
  error: null,
  isFetching: { BPU: false, CPU: false, K8P: false },
  reports: { BPU: null, CPU: null, K8P: null },
}

export default (state = initialState, action) => {
  switch (action.type) {
    case types.FETCHING_REPORT: {
      return {
        ...state,
        error: null,
        isFetching: {
          ...state.isFetching,
          [action.program]: true,
        },
        reports: {
          ...state.reports,
          [action.program]: null,
        },
      }
    }

    case types.FETCHING_REPORT_ERROR: {
      const error =
        typeof action.error === 'string'
          ? new Error(action.error)
          : action.error
      console.error(typeof action.error, action.error, error)
      return {
        ...state,
        error: action.error,
        isFetching: {
          ...state.isFetching,
          [action.program]: false,
        },
      }
    }

    case types.FETCHING_REPORT_SUCCESS: {
      return {
        ...state,
        error: null,
        isFetching: {
          ...state.isFetching,
          [action.program]: false,
        },
        reports: {
          ...state.reports,
          [action.program]: action.reportData,
        },
      }
    }

    case types.DELETE_REPORTS_SUCCESS: {
      return {
        ...initialState,
      }
    }

    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/redux/reports/reducers.js